import { WorkRequirementWhoScreen } from "@/interactors/WorkRequirementWhoScreen";

export default function WorkRequirementWho() {
  return <WorkRequirementWhoScreen />;
}
